import React, { useEffect, useRef } from 'react';
import piriai_guide from '../../assets/videos/userguide/piriai_guide.mp4';
import guide_tr from '../../assets/videos/userguide/guide_tr.mp4';
import guide_az from '../../assets/videos/userguide/guide_az.mp4';
import guide_fr from '../../assets/videos/userguide/guide_fr.mp4';
import guide_kk from '../../assets/videos/userguide/guide_kk.mp4';
import guide_kz from '../../assets/videos/userguide/guide_kz.mp4';
import guide_ru from '../../assets/videos/userguide/guide_ru.mp4';
import guide_uz from '../../assets/videos/userguide/guide_uz.mp4';
import guide_en from '../../assets/videos/userguide/guide_en.mp4';
import guide_es from '../../assets/videos/userguide/guide_es.mp4';
import guide_ar from '../../assets/videos/userguide/guide_ar.mp4';

import { useTranslation } from 'react-i18next';


const VideoModal = ({ isOpen, onClose }) => {
    const { i18n } = useTranslation();
    const dialogRef = useRef(null);

    // Dil koduna göre video dosyasını eşle
    const videoSources = {
        tr: guide_tr,
        az: guide_az,
        fr: guide_fr,
        kk: guide_kk,
        kz: guide_kz,
        ru: guide_ru,
        uz: guide_uz,
        en: guide_en,
        es: guide_es,
        ar: guide_ar,
    };

    // i18n.language varsayılan olarak olabilir 'tr' değilse ya da tanımlı değilse fallback yap
    const currentLang = i18n.language || 'tr';
    const videoSrc = videoSources[currentLang] || piriai_guide; // varsayılan video

    useEffect(() => {
        if (isOpen) {
            dialogRef.current?.showModal();
        } else {
            dialogRef.current?.close();
        }
    }, [isOpen]);

    return (
        <dialog
            ref={dialogRef}
            className="fixed inset-0 p-0 m-auto w-[90%] max-w-4xl h-auto bg-transparent backdrop:bg-black backdrop:bg-opacity-50"
            onClick={(e) => {
                const dialogDimensions = dialogRef.current.getBoundingClientRect();
                if (
                    e.clientX < dialogDimensions.left ||
                    e.clientX > dialogDimensions.right ||
                    e.clientY < dialogDimensions.top ||
                    e.clientY > dialogDimensions.bottom
                ) {
                    onClose();
                }
            }}
        >
            <div className="bg-white rounded-lg p-4">
                <div className="flex justify-end mb-2">
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>
                <video
                    className="w-full rounded-lg"
                    controls
                    autoPlay={false}
                    key={videoSrc} // video src değiştiğinde video yenilenir
                >
                    <source src={videoSrc} type="video/mp4" />
                    Tarayıcınız video elementini desteklemiyor.
                </video>
            </div>
        </dialog>
    );
};


export default VideoModal;